import React, { useState, useEffect, useReducer } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { useToasts } from 'react-toast-notifications';
import { VEND_BETTING } from '../../../utils/constants';
import { setCurrentPage } from '../../../actions/page';
import BettingPaymentForm from './BettingPaymentForm';
import BettingPaymentSummary from './BettingPaymentSummary';
import BettingPaymentCompleted from './BettingPaymentCompleted';
import FailedTransaction from '../../../components/common/FailedTransaction';
import BettingPaymentReducer, { initialFormState } from './payment-reducer';
// import { pink } from '@material-ui/core/colors';

export const BettingPayment = ({ service, hasSetPin }) => {
    console.log(service);
    const TRANSACTION_COST = 0;
    let renderedComponent;
    const [componentToRender, setComponentToRender] = useState('form');
    const [BettingPaymentFormState, dispatch] = useReducer(
        BettingPaymentReducer,
        initialFormState
    );
    
    const [loading, setLoading] = useState(false);
    const [successData, setSuccessData] = useState(null);
    const [agentLocation, setAgentLocation] = useState(null);
    const [failedErrorMessage, setFailedErrorMessage] = useState('');
    const { addToast } = useToasts();

    
    const getTransactionDate = (date) => {
        const dateString = date.toLocaleDateString();
        return dateString.slice(0, 24);
    };

    useEffect(() => {
        if ('geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition(function (position) {
                setAgentLocation({
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude,
                });
            });
        }
    }, []);

    const handleOnSubmit = () => {
        setLoading(true);

        let providerApi;
        let payload;
        const { smartCardNumber, amount, selectedPlanCode, cycle, phone, transaction_pin } =
            BettingPaymentFormState;

            providerApi = VEND_BETTING;
            payload = {
                customer_id: smartCardNumber,
                type: service,
                package: selectedPlanCode,
                amount,
                phone,
                transaction_pin:transaction_pin,
            };

        (async function vendBetting() {
            try {
                const res = await axios.post(providerApi, payload);
                const successData = res.data.data;
                const message = res.data.data.message;
                const date = new Date();
                const transactionDate = getTransactionDate(date);

                setLoading(false);
                setSuccessData({ ...successData, date: transactionDate });
                addToast(message, {
                    appearance: 'success',
                    autoDismiss: true,
                });
                setComponentToRender('success');
            } catch (e) {
                setLoading(false);
                addToast(e.response.data.data, {
                    appearance: 'error',
                    autoDismiss: true,
                });
                setFailedErrorMessage(e.response.data.message || undefined);
                setComponentToRender('failed');
            }
        })();
    };
    
    switch (componentToRender) {
        case 'form':
            
            console.log('service1');
            renderedComponent = (
                <BettingPaymentForm
                    setComponentToRender={setComponentToRender}
                    setFormState={dispatch}
                    service={service}
                    BettingPaymentFormState={BettingPaymentFormState}
                />
            );
            break;
        case 'summary':
            renderedComponent = (
                <BettingPaymentSummary
                    BettingPaymentFormState={BettingPaymentFormState}
                    handleOnSubmit={handleOnSubmit}
                    setComponentToRender={setComponentToRender}
                    loading={loading}
                    service={service}
                    hasSetPin={hasSetPin}
                    dispatch={dispatch}
                    transactionCost={TRANSACTION_COST}
                />
            );
            break;
        case 'success':
            renderedComponent = (
                <BettingPaymentCompleted
                    successData={successData}
                    formState={BettingPaymentFormState}
                    setComponentToRender={setComponentToRender}
                    transactionCost={TRANSACTION_COST}
                    service={service}
                    BettingPaymentFormState={BettingPaymentFormState}
                />
            );
            break;
        case 'failed':
            renderedComponent =  <FailedTransaction message={failedErrorMessage} />
            break;
        default:
            renderedComponent = null;
            console.log('service');
    }

    return <div>{renderedComponent}</div>;
};

const mapStateToProps = (state) => {
    return {
        service: state.modal.service,
        hasSetPin: state.auth.user.hasSetPin,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeCurrentPage: (payload) => dispatch(setCurrentPage(payload)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(BettingPayment);
